export const LOAN_STATUS = {
  PENDING: 'Pending',
  CLOSED: 'Closed',
  DELETED: 'Deleted',
};
